import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { SpinnerDotted } from "spinners-react";
const Inicio = React.lazy(() => import("./pages/Inicio/Inicio"));
const Reclamo = React.lazy(() => import("./pages/Reclamo/Reclamo"));
const Pdf = React.lazy(() => import("./pages/Pdf/Pdf"));

// const PrivateRoute = ({ children, ...rest }) => {
//   return (
//     <Route
//       {...rest}
//       render={({ location }) =>
//         sessionStorage.getItem("dG9rZW4=") ? (
//           children
//         ) : (
//           <Redirect
//             to={{
//               pathname: "/",
//               state: { from: location },
//             }}
//           />
//         )
//       }
//     />
//   );
// };

const App = () => {
  return (
    <Router>
      <Suspense
        fallback={
          <div className="container spinner-container">
            <div className="col-12 d-flex justify-content-center">
              <SpinnerDotted
                size={150}
                thickness={100}
                speed={100}
                color="#fdba30"
              />
            </div>
          </div>
        }
      >
        <Route path="/" exact>
          <Inicio />
        </Route>
        <Route path="/pdf">
          <Pdf />
        </Route>
        <Route path="/reclamo">
          <Reclamo />
        </Route>
      </Suspense>
    </Router>
  );
};

export default App;
